const idToName = {
	// 下单催付-下单关怀（货到）
	11: '下单关怀（货到）',
	// 下单催付-常规催付
	8: '常规催付',
	// 下单催付-二次催付
	12: '二次催付',
	// 下单催付-预售尾款催付
	24: '预售尾款催付',
	// 付款关怀-付款关怀
	1: '付款关怀',
	// 物流提醒-取消提醒
	6: '取消提醒',
	// 物流提醒-发货提醒
	2: '发货提醒',
	// 物流提醒-迟发提醒
	3: '迟发提醒',
	// 物流提醒-派件提醒
	13: '派件提醒',
	// 物流提醒-签收提醒
	14: '签收提醒',
	// 物流提醒-退货提醒
	7: '退货提醒',
	// 回款关怀-完成提醒
	5: '完成提醒',
	// 评价关怀-自动催评
	41: '自动催评',
	// 评价关怀-好评感谢
	42: '好评感谢',
	// 评价关怀-中差评安抚
	43: '中差评安抚',
	// 退款关怀-申请退款
	51: '申请退款',
	// 退款关怀-同意退款
	52: '同意退款',
	// 退款关怀-拒绝退款
	53: '拒绝退款',
	// 退款关怀-退款成功
	54: '退款成功',
	// 精准营销-精准营销
	61: '精准营销',
	// 精准营销-智能营销
	62: '智能营销',
	// 精准营销-会员发送
	63: '会员发送',
	// 精准营销-订单发送
	64: '订单发送',
	// 精准营销-预售订单发送
	65: '预售订单发送',
	// 咚咚群聊-群聊营销
	66: '群聊营销',
	// 自动化营销-商品复购
	25: '商品复购',
	// 自动化营销-首购有礼
	15: '首购有礼',
	// 自动化营销-复购有礼
	16: '复购有礼',
	// 自动化营销-休眠提醒
	17: '休眠提醒',
	// 自动化营销-满月礼
	18: '满月礼',
	// 自动化营销-百日礼
	19: '百日礼',
	// 自动化营销-周年庆
	20: '周年庆',
	// 自动化营销模型-开卡未购会员转化
	75: '开卡未购会员转化',
	// 自动化营销模型-已购客户开卡转化
	76: '已购客户开卡转化',
	// 自动化营销模型-首购有礼
	71: '首购有礼',
	// 自动化营销模型-复购有礼
	72: '复购有礼',
	// 自动化营销模型-兴趣客户转化
	74: '兴趣客户转化',
	// 自动化营销模型-流失客户召回
	73: '流失客户召回',
	// 自动化营销模型-商品复购
	84: '商品复购',
	// 自动化营销模型-直播提醒
	77: '直播提醒',
	// 自动化营销模型-店铺上新提醒
	78: '店铺上新提醒',
	// 自动化营销模型-会员专享活动提醒
	79: '会员专享活动提醒',
	// 自动化营销模型-会员积分使用提醒
	80: '会员积分使用提醒',
	// 自动化营销模型-沉默会员召回-行业活跃
	81: '沉默会员召回-行业活跃',
	// 自动化营销模型-店铺预售高潜人群关怀
	82: '店铺预售高潜人群关怀',
	// 自动化营销模型-算法大促高转化人群营销
	83: '算法大促高转化人群营销',
}
export default idToName